var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useColorContext } from '../../providers/ColorContext';
import { StyledComponent } from './styles';
export function TypographyFactory(_a) {
    var { children = null, type, asHTMLTag, color: colorProp = undefined, 'data-testid': testId, weight, size, align = undefined, whiteSpace = 'normal', fontFamily } = _a, rest = __rest(_a, ["children", "type", "asHTMLTag", "color", 'data-testid', "weight", "size", "align", "whiteSpace", "fontFamily"]);
    const colorContext = useColorContext();
    const color = colorProp || (colorContext === 'dark' ? 'white' : 'darkergrey');
    return (React.createElement(StyledComponent, Object.assign({}, rest, { as: asHTMLTag, "data-testid": testId, "$color": color, "$type": type, "$weight": weight, "$size": size, "$align": align, "$whiteSpace": whiteSpace, "$fontFamily": fontFamily }), children));
}
